const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function randomUuidV4FromGetRandomValues(): string | null {
  const cryptoObj = typeof crypto !== 'undefined' ? crypto : undefined;
  if (!cryptoObj || typeof cryptoObj.getRandomValues !== 'function') return null;
  const bytes = new Uint8Array(16);
  cryptoObj.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
  return `${hex[0]}${hex[1]}${hex[2]}${hex[3]}-${hex[4]}${hex[5]}-${hex[6]}${hex[7]}-${hex[8]}${hex[9]}-${hex[10]}${hex[11]}${hex[12]}${hex[13]}${hex[14]}${hex[15]}`;
}

function randomUuidV4FromMathRandom(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = Math.floor(Math.random() * 16);
    const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
    return value.toString(16);
  });
}

/** UUID v4 para IDs client-side (sessionId, outflowId). */
export function newClientUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const fromGetRandomValues = randomUuidV4FromGetRandomValues();
  if (fromGetRandomValues && UUID_V4_REGEX.test(fromGetRandomValues)) {
    return fromGetRandomValues;
  }
  return randomUuidV4FromMathRandom();
}

export { UUID_V4_REGEX };
